import { useSearchParams } from "react-router-dom";
import { Link } from "@/i18n/LangRouting";
import { Ticket } from "lucide-react";
import { useExhibition } from "@/visitor/ExhibitionShell";
import Header from "@/visitor/Header";
import { giftName } from "@/lib/gifts";

export default function VoucherPage() {
  const { slug, exhibition, visitor, t, prefix, lang } = useExhibition();
  const gift = giftName(exhibition, lang, t);
  const [params] = useSearchParams();
  const next = params.get("next") || `${prefix}/e/${slug}`;
  if (!visitor?.code) return <Link to={`/e/${slug}`} className="block p-10 text-center text-[var(--muted)]">{t("voucher_continue")}</Link>;
  return (
    <div className="min-h-screen" data-testid="voucher-page">
      <Header back={`/e/${slug}`} label={exhibition.name} />
      <div className="max-w-md mx-auto px-6 py-12 fade-up">
        <Ticket size={40} className="text-accent" />
        <h1 className="font-display text-4xl sm:text-5xl uppercase leading-[0.95] mt-5" data-testid="voucher-title">{t("voucher_title", { gift })}</h1>
        <p className="text-[var(--muted)] mt-4">{t("voucher_sub", { gift })}</p>
        <div className="mt-8 border-2 border-dashed border-[var(--accent)] p-6">
          <p className="label">{t("voucher_name_label")}</p>
          <p className="text-lg" data-testid="voucher-name">{visitor.first_name} {visitor.last_name}</p>
          <p className="label mt-5">{t("voucher_code_label")}</p>
          <p className="font-display text-4xl tracking-wider text-accent break-all" data-testid="voucher-code">{visitor.code}</p>
          <p className="text-xs text-[var(--muted)] mt-4">{exhibition.name} · {new Date().toLocaleDateString()}</p>
        </div>
        <Link to={next} className="btn-accent w-full py-4 mt-8 block text-center" data-testid="voucher-continue">{t("voucher_continue")}</Link>
      </div>
    </div>
  );
}
